import React, { useRef, useEffect, useCallback } from 'react';
import DesktopInputs from './DesktopInputs';
import MobileInputs from './MobileInputs';
import useIsMobile from '@hooks/useIsMobile';
import useHasRendered from '@hooks/useHasRendered';

export default function InputsWrapper({
  inputsAreOpen,
  state,
  prevState,
  canRefresh,
  setInputsAreOpen,
  setState,
  setCanValidate,
  ...rest
}) {
  const isMobile = useIsMobile();
  const prevIsMobile = useRef(isMobile);

  useEffect(() => {
    if (isMobile && !prevIsMobile.current) {
      setInputsAreOpen(false);
    }

    prevIsMobile.current = isMobile;
  }, [isMobile, setInputsAreOpen]);

  const cancel = useCallback(() => {
    if (prevState) {
      setState(prevState);
    }

    setInputsAreOpen(false);
    setCanValidate([]);
  }, [prevState, setState, setInputsAreOpen, setCanValidate]);

  const Tag = isMobile ? MobileInputs : DesktopInputs;

  const props = {
    state,
    prevState,
    canRefresh,
    inputsAreOpen,
    setInputsAreOpen,
    setState,
    cancel,
    setCanValidate,
    ...rest
  };

  const hasRendered = useHasRendered();

  return hasRendered ? (
    <Tag {...props} />
  ) : (
    <>
      <DesktopInputs {...props} />
      <MobileInputs {...props} />
    </>
  );
}
